document.addEventListener("DOMContentLoaded", function () {
  var link = document.createElement("link");
  var script = document.createElement("script");

  // Injecting the widget's CSS:
  link.href = process.env.PUBLIC_URL + "/index.css";
  link.rel = "stylesheet";
  document.head.appendChild(link);

  // Injecting the widget's JS:
  script.src = process.env.PUBLIC_URL + "/index.js";
  script.async = true;
  document.head.appendChild(script);

  function pcwInit() {
    // Waiting for the script to load:
    if (typeof window.renderWidget === "function") {
      // Checking if the company access name has been configured:
      if (!window.pcwNewsroomId) {
        console.error("PressCorner widget: No company access name provided, cannot initialize the widget!");

        return;
      }

      // If the target container is not set, use the default:
      if (!window.pcwTargetContainer) {
        window.pcwTargetContainer = "unn-presscorner-widget";
      }

      // Rendering the widget:
      window.renderWidget(window.pcwNewsroomId, window.pcwTargetContainer, {});
    } else {
      // Checking again after 100ms:
      setTimeout(pcwInit, 100);
    }
  }
  pcwInit();
});
